import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { flatMap as _flatmap } from 'lodash';
import { cloneDeep as _cloneDeep } from 'lodash';
import { CustomPriorityByEventType, EventTypeModel, TemplatePriorityModel } from '@/app/model/template.priority.model';
import { DropdownEntry } from '@/app/model/dropdown-entry';

interface EventType {
  name: string,
  display_label: string
}
interface EventTypeSwitcher extends EventType {
  switcher: Array<any>,
  priorityIndex: number,
  priority: string
}

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, OnChanges {
  @Input() public templatePriority: TemplatePriorityModel;
  @Input() public eventTypes: EventTypeModel[] = [];
  @Input() public dropdownSelectedEntries: Array<DropdownEntry> = [];

  @Output() public close = new EventEmitter<any>();

  public templateEventTypes: Array<EventType> = [];
  public templateEventTypeSwitchers: Array<EventTypeSwitcher> = [];
  public templateEditedEventTypeSwitchers: Array<EventTypeSwitcher> = [];
  private switcherValue: string;
  private switcherIndex: number;
  public defaultHeaderContent: boolean = true;

  private switcherValuesMap = {
    HIGH: 2,
    MEDIUM: 1,
    LOW: 0
  }

  public openConfirmCustomizationsModal: boolean = false;

  constructor() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.templatePriority?.currentValue) {
      //// Intercepted change in templatePriority
      // Map Template Event Types
      this.templateEventTypes = changes.templatePriority.currentValue.event_types
        .map((value: any) => ({
          name: value,
          display_label: this._buildEventTypeDisplayLabel(value)
        }));
      //// Add possible missing event types
      // for each customPriority in customization.priorities
      changes.templatePriority.currentValue.customizations?.forEach((customPriority: CustomPriorityByEventType) => {
        // check if the eventType is already present
        if (!this.templateEventTypes.find((eventType: EventType) => eventType.name === customPriority.event_type)) {
          // if not, add it
          this.templateEventTypes.push({
            name: customPriority.event_type,
            display_label: this._buildEventTypeDisplayLabel(customPriority.event_type)
          });
        }
      });
      // Sort Event Types
      this.templateEventTypes = this.templateEventTypes.sort((a: EventType, b: EventType) => a.name.localeCompare(b.name));
      // Build Template Event Type Switchers for each event type
      this.templateEventTypeSwitchers = this.templateEventTypes.map((eventType: EventType) => {
        // Default priority assigned
        let priorityIndex = this.switcherValuesMap[this.templatePriority.priority];
        let priority = this.templatePriority.priority;
        // check if it's configured a custom priority
        const customPriority: CustomPriorityByEventType = this.templatePriority?.customizations?.find(p => p.event_type === eventType.name);
        if (customPriority) {
          // if yes, assign the custom priority
          priorityIndex = this.switcherValuesMap[customPriority.priority];
          priority = customPriority.priority;
        }
        // return the switcher object
        return {
          ...eventType,
          switcher: [
            { title: "Low", data: { title: "LOW" } },
            { title: "Medium", data: { title: "MEDIUM" } },
            { title: "High", data: { title: "HIGH" } }
          ],
          priorityIndex: priorityIndex,
          priority: priority
        }
      });
      this.templateEditedEventTypeSwitchers = JSON.parse(JSON.stringify(this.templateEventTypeSwitchers));
    }
  }

  ngOnInit(): void {
    
  }

  //Switcher Button Clicked
  switcherComponent = (event: any) => {
    this.switcherValue = event.title;
  }

  setIndexContentChosed = (valueIndex?: any) => {
    this.switcherIndex = valueIndex;
  }

  setSwitcherValue(event: any, eventTypeSwitcher: EventTypeSwitcher) {
    this.templateEditedEventTypeSwitchers.forEach((ets: EventTypeSwitcher) => {
      if (ets.name === eventTypeSwitcher.name) {
        ets.priority = this.switcherValue;
        ets.priorityIndex = this.switcherIndex;
      }
    });
  }

  //Close SideBar
  handleOpenCloseInteraction = (value) => {
    this.handleCancelButtonInteraction(value);
  }

  handleCancelButtonInteraction = (value) => {
    this.close.emit(value);
  }

  handleApplyButtonInteraction = () => {
    this.openConfirmCustomizationsModal = true;
  }

  openCloseConfirmCustomizationsModal(event) {
    this.openConfirmCustomizationsModal = false;
    if (event.status) {
      this._confirmCustomizations();
    }
  }

  private _confirmCustomizations() {
    this.templatePriority.customizations = [];
    const customPriorities: CustomPriorityByEventType[] = this.templateEditedEventTypeSwitchers
      .map((ets: EventTypeSwitcher) => ({
        event_type: ets.name,
        priority: ets.priority
      }));
    this.templatePriority.customizations = customPriorities;
    this.close.emit(this.templatePriority);
  }

  private _buildEventTypeDisplayLabel(eventType: string): string {
    return eventType.split('_').map(splittedItem => splittedItem[0].toUpperCase() + splittedItem.slice(1).toLowerCase()).join(' ');
  }
  
}
